export default "/images/clear_x.svg"